export default {"src":"/_next/static/media/alert.76778775.svg","height":15,"width":15,"blurWidth":0,"blurHeight":0};